import Rails from '@rails/ujs';
import TaskAssignation from '../utils/TaskAssignation';

export default class BackofficeTasksIndex {
  constructor() {
    this.bindEvents();
    this.taskAssignation = new TaskAssignation();
  }

  bindEvents() {
    $(".tasks-datatable").dataTable({
      searching: false,
      order: [[2, 'asc']],
      language: {
        url: '/data-tables/locales/' + I18n.locale + '.json'
      }
    })

    $(".action-tasks-datatable").dataTable({
      searching: false,
      order: [[2, 'asc']],
      language: {
        url: '/data-tables/locales/' + I18n.locale + '.json'
      }
    })

    $(".actions-btn").on('click', this.showActionsModal);
  }

  showActionsModal() {
    const url = $(this).data('url');

    Rails.ajax({
      url: url,
      type: 'GET',
      success: function(data, _status, xhr) {
        const html = xhr.responseText;
        $("#actions-modal-body").html(html);
        $("#actions-modal").modal('show');
      }
    });
  }

  
  onDataChanged(data) {
  }

  onDestroy() {
    this.taskAssignation.onDestroy();
    $(".tasks-datatable").DataTable().destroy();
    $(".action-tasks-datatable").DataTable().destroy();
    $(".actions-btn").off('click', this.showActionsModal);
  }
}